import { ITransportDetailSection } from 'types/transport'
import { ISelectOption } from 'components/common/CustomSelect';
import { stepStatusSelect } from 'data/transport';
import DetailInfoArea from 'components/transport/DetailInfoArea';
import Loading from 'components/common/Loading';

const CargoIn = ({ detailInfo, transportInfo, loading }: ITransportDetailSection) => {
    const statusDefault = (option: ISelectOption[]): ISelectOption => {
        if (!detailInfo) return option[0] as ISelectOption
        if (!detailInfo.stepStatus) return option[0] as ISelectOption
        const status = detailInfo.stepStatus.toString();

        const filtered = option.filter(arr => arr.value === status);
        if (!filtered) return option[0] as ISelectOption
        return filtered[0]
    }

    if (loading) return <div className='flex justify-center items-center h-96'><Loading /></div>

    return (
        <div className='flex flex-col justify-start items-start gap-6 px-10 py-6 text-lg'>
            {
                transportInfo?.shipmentMode.includes('FCL') &&
                <DetailInfoArea
                    title='씰넘버'
                    value={detailInfo?.detailInfo?.sealNumber ?? ''}
                />
            }
            <DetailInfoArea
                title='운송단계상태'
                value={statusDefault(stepStatusSelect).label}
            />
            <DetailInfoArea
                title='일시'
                value={detailInfo?.detailInfo?.startAt ?? ''}
            />
        </div>
    )
}

export default CargoIn